import { Component, OnInit, Inject } from '@angular/core';
import { UntypedFormGroup, UntypedFormControl, Validators } from '@angular/forms';
import { AlertComponent } from '../../common/alert/alert.component';
import { Refinery } from '../../models/refinery.model';
import { Tenant } from '../../models/tenant.model';
import { adminService } from '../../services/admin.service';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { KeyvaultComponent } from 'src/app/keyvault/keyvault.component';
import { GlobalService } from '../../services/global.service';
import { RefineryService } from '../../services/refinery.service';
import * as moment from 'moment';

@Component({
  selector: 'app-tenant-page',
  templateUrl: './tenant-page.component.html',
  styleUrls: ['./tenant-page.component.css']
})
export class TenantPageComponent implements OnInit {

  isLoading = false;

  refineryMap: Refinery[];

  public tenantDetailForm = new UntypedFormGroup({
    tenantId: new UntypedFormControl(''),
    tenantName: new UntypedFormControl({ value: '', disabled: false }, Validators.required),
    tenantSecurityGrp: new UntypedFormControl({ value: '', disabled: false }, Validators.required),
    tenantEmailId: new UntypedFormControl({ value: '', disabled: false }, Validators.required),
    refineryId: new UntypedFormControl({ value: '', disabled: false }, Validators.required),
    tenantKeyvaultUrl: new UntypedFormControl({ value: '', disabled: false }, Validators.required)
  });
  constructor(public dialogRef: MatDialogRef<TenantPageComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any, public globalService: GlobalService,
    public dialog: MatDialog, private readonly refineryService: RefineryService, private readonly adminservice: adminService) { }

  ngOnInit(): void {
    this.refineryService.getRefineryListFromServer();
    this.refineryService.getRefineries().subscribe((data: Refinery[]) => {
      this.refineryMap = data;
    });
    this.loadTenantPageData();
  }

  loadTenantPageData() {
    this.isLoading = true;
    if (this.globalService.isNotNullObject(this.data.data) && this.data.displayType !== 'add') {
      let disableMode = false;
      let isTenantDisabled = false;
      if (this.data.displayType === 'view') {
        disableMode = true;
        isTenantDisabled = true;
      }
      if (this.data.displayType === 'edit') {
        isTenantDisabled = true;
      }
      this.tenantDetailForm = new UntypedFormGroup({
        tenantId: new UntypedFormControl({ value: this.data.data.tenantId, disabled: isTenantDisabled }, Validators.required),
        tenantName: new UntypedFormControl({ value: this.data.data.tenantName, disabled: isTenantDisabled }, Validators.required),
        tenantSecurityGrp: new UntypedFormControl({ value: this.data.data.tenantSecurityGrp, disabled: disableMode }, Validators.required),
        tenantEmailId: new UntypedFormControl({ value: this.data.data.tenantEmailId, disabled: disableMode }, Validators.required),
        refineryId: new UntypedFormControl({ value: this.data.data.refineryId, disabled: isTenantDisabled }, Validators.required),
        tenantKeyvaultUrl: new UntypedFormControl({ value: this.data.data.tenantKeyvaultUrl, disabled: disableMode }, Validators.required)
      });
      this.isLoading = false;
    } else {
      this.isLoading = false;
    }
  }

  onRefineryChange() {

  }

  disableSave() {
    const check: boolean = !this.tenantDetailForm.valid;
    return check;
  }

  saveTenant() {
    const tenantData: Tenant = this.tenantDetailForm.value;
    tenantData.tenantId = this.tenantDetailForm.controls.tenantId.value;
    tenantData.tenantName = this.tenantDetailForm.controls.tenantName.value;
    tenantData.refineryId = this.tenantDetailForm.controls.refineryId.value;
    tenantData.tenantRefinery = this.refineryMap.find((item: Refinery) => item.refineryId === tenantData.refineryId).refineryShortName;
    if (this.data.displayType === 'add') {
      tenantData.tenantId = 0;
      tenantData.createdBy = this.globalService.loggedInUser;
      tenantData.createdTime = moment.utc(new Date()).local().format('YYYY-MM-DDTHH:mm:ss');
    }
    tenantData.lastModifiedBy = this.globalService.loggedInUser;
    tenantData.lastModifiedTime = moment.utc(new Date()).local().format('YYYY-MM-DDTHH:mm:ss');
    this.adminservice.saveTenant(tenantData, this.data.displayType).subscribe((data: any): void => {
      this.globalService.showAlert(AlertComponent, { success: true, message: 'Tenant ' + this.tenantDetailForm.get('tenantName').value + ' saved successfully.' });
      this.onCancelClick(true);
    }, (error: Error) => {
      this.isLoading = false;
      this.globalService.showAlert(AlertComponent, { success: false, message: 'Tenant ' + this.tenantDetailForm.get('tenantName').value + ' could not be saved.' });
    });
  }

  openKeyvaultPopup() {
    this.globalService.openModelWindow(this.setkeyVaultUrl, this, KeyvaultComponent, '40%', 'custom-modalbox',
      this.tenantDetailForm.controls['tenantName'].value);
  }

  /**
   * takes input from key vault popup
   * @param thisref
   * @param result
   */
  setkeyVaultUrl(thisref, result) {
    if(result) {
      thisref.tenantDetailForm.controls['tenantKeyvaultUrl'].setValue(result + '/');
    }
  }

  /**Cancels the pop-up */
  onCancelClick(value: boolean): void {
    this.dialogRef.close(value);
  }

}
